import { LoupeIcon } from './LoupeIcon';

/**
 * author: Google
 * id DB75FD27-01F6-4232-AA23-86C115751A0C
 * name loupe
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/loupe.svg
 * tags
 */
export const CirclePlusOutlineIcon = LoupeIcon;
export default CirclePlusOutlineIcon